import { apiFetch } from './client.js';

export interface ApiMetaResponse {
  environment: string;
  capabilities: {
    deleteRun: boolean;
  };
}

export function getApiMeta(jwt: string | null): Promise<ApiMetaResponse> {
  return apiFetch<ApiMetaResponse>('/api/meta', { jwt, method: 'GET' });
}
